<template>
	<v-form ref="form" v-model="valid" @keyup.native.enter="valid && submit($event)">
		<v-text-field
      v-model="password"
      :rules="passwordRules"
      type="password"
      :label="this.$store.getters['translate/translater']
      .__('Password', 'users')"
      required
    ></v-text-field>
    <v-text-field
      v-model="passwordConfirmation"
      :rules="validateConfirmation()"
      type="password"
      :label="this.$store.getters['translate/translater']
      .__('Confirm password', 'users')"
      required
    ></v-text-field>
    <v-btn small
      :disabled="!valid"
      class="success"
      @click="submit"
    >
    
      {{this.$store.getters['translate/translater']
      .__('Save')}}
    </v-btn>

    <v-btn small
      
      
      @click="cancel"
    >
    
      {{this.$store.getters['translate/translater']
      .__('Cancel')}}
    </v-btn>
	</v-form>
</template>

<script>
	import {passwordRules} from '../../validation/users'
  	import {capitalizeFirstLetter} from '../../tools'
  	import {translater} from '../../tools/translate';
  	import {confirmationRules} from '../../validation/users'
	export default {
		name: 'UsersChangePassword',
		data()
		{
			return {
				valid: false,
				
				
				passwordRules: passwordRules,
				confirmationRules: confirmationRules
				
			}
		},

		created()
		{
			
			this.$store.dispatch('users/getEdit', this.$route.params.id)

		},

		beforeRouteLeave(to, from , next)
		{
			this.$store.dispatch('users/flush');
			next();
		},

		methods: {
			submit(){
				if(this.$refs.form.validate())
				{
					this.$store.dispatch('users/changePassword')
					.then((res) => {
						
						this.$store.dispatch('success/setMessage', this.$store.getters['translate/translater'].__('Password changed successfully', 'users'));
						this.$router.push({name: 'usersIndex'});

						setTimeout(() => {
							this.$store.dispatch('success/setMessage', undefined);
						}, 2000)



					})
					.catch((err) => {
						this.$store.dispatch('error/setError', this.$store.getters['translate/translater'].__('Error changing password'));
						

						setTimeout(() => {
							this.$store.dispatch('error/setError', undefined);
						}, 2000)
					})
				}
			},
			cancel(){
				
				this.$router.push({name: 'usersIndex'});
			},
			validateConfirmation(){
				
				let pw = this.$store.getters['users/get'].password
				
				return confirmationRules(pw)
			}
		},

		computed: {
			
			password: {
				get: function()
				{
					return this.$store.getters['users/get'].password;
				},

				set: function(value)
				{
					this.$store.dispatch('users/setPassword', value);
				}
			},

			passwordConfirmation: {
				get: function()
				{
					return this.$store.getters['users/getPasswordConfirmation'];
				},

				set: function(value)
				{
					this.$store.dispatch('users/setPasswordConfirmation', value);
				}
			},
		}

	}
</script>